module.exports = __webpack_public_path__ + "static/media/msg_fail.3c4f83e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/msg_fail.mp3
// module id = z4Mi
// module chunks = 1